export const langWords = {
  general: {
    code: "p",
    list: [
      "aCustomer",
      "anItem",
      "askGuaranteeDoc",
      "aSupplier",
      "thisCustomer",
      "thisItem",
      "thisSupplier",
      "customer",
      "helper",
      "intervention",
      "item",
      "issues",
      "newCAT",
      "newPRO",
      "newPED",
      "newENT",
      "newCFA",
      "newDEV",
      "newSAL",
      "newTRA",
      "newCOT",
      "newORD",
      "newPRE",
      "newFAC",
      "newREG",
      "newTAL",
      "newSDA",
      "occasionalCustomer",
      "purchases",
      "sales",
      "seller",
      "service",
      "serviceAndGuarantee",
      "services",
      "supplier",
      "technician",
    ],
  },
  purchasesMenu: {
    code: "c",
    list: ["A1", "A2", "A3", "A4", "A5", "A6", "A7"],
  },
  purchases: {
    code: "c",
    list: ["PRO", "PRO2", "PED", "ENT", "CFA", "REG", "SALP", "TRA", "TRA2"],
  },
  salesMenu: { code: "c", list: ["B1", "B2", "B3", "B4", "B5", "B6", "B7"] },
  sales: {
    code: "c",
    list: ["CLI", "CLI2", "COT", "ORD", "PREP", "FAC", "ALC", "DEV", "SEV"],
  },
  servicesMenu: { code: "c", list: ["C1", "C2", "C3"] },
  lists: {
    code: "c",
    list: [
      "ID",
      "ID2",
      "ANO",
      "AGE",
      "DEL",
      "INT",
      "INTN",
      "TEC",
      "PER",
      "ART",
      "COD",
      "COD2",
      "COMP",
      "CAN",
      "GAR",
      "C1G",
      "LIS",
      "NOM",
      "NOMCAT",
      "NOMPAG",
      "NOMPSE",
      "TEL",
      "CEL",
      "PAD",
      "PCO",
      "EMA",
      "EMA1",
      "FEC2",
      "FECDOC",
      "SDA",
      "PAG",
      "PAG2",
      "TAL",
      "RUC",
      "SELVEN",
      "ARTSE0",
      "NOMSE0",
    ],
  },
  warehouse: {
    code: "c",
    list: ["F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10"],
  },
  admin: {
    code: "c",
    list: [
      "D1",
      "D2",
      "D3",
      "D4",
      "D5",
      "D6",
      "D7",
      "D8",
      "D9",
      "D10",
      "D11",
      "D12",
    ],
  },
  settings: {
    code: "c",
    list: [
      // "Z1",
      // "Z2",
      // "Z3",
      // "Z4",
      // "Z5",
      // "Z6",
      "Z7",
      // "Z8",
      // "Z9",
      // "Z10",
      // "Z11",
      // "Z12",
      // "Z13",
      // "Z14",
    ],
  },
  document: {
    code: "d",
    list: ["CLI", "FEC2", "FEC2P", "INT", "TAL", "GAR"],
  },
};
